var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEyeoff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Eye off"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.00254 4.01231C5.26474 4.01003 5.51734 4.11082 5.70594 4.29298L7.48694 6.07398C8.88544 5.36583 10.4314 4.99785 11.9989 4.99998C16.4769 4.99998 20.2669 7.94298 21.5409 12C20.9422 13.8999 19.7905 15.5781 18.2329 16.82L19.7059 18.293C19.8881 18.4816 19.9889 18.7342 19.9866 18.9964C19.9843 19.2586 19.8792 19.5094 19.6938 19.6948C19.5084 19.8802 19.2575 19.9854 18.9953 19.9877C18.7331 19.9899 18.4805 19.8891 18.2919 19.707L4.29194 5.70698C4.10978 5.51838 4.00899 5.26578 4.01127 5.00358C4.01355 4.74138 4.11872 4.49057 4.30412 4.30516C4.48953 4.11975 4.74034 4.01458 5.00254 4.01231ZM9.96694 8.55298C9.96673 8.5531 9.96715 8.55286 9.96694 8.55298V8.55298ZM9.96694 8.55298L11.4809 10.068C11.82 9.97793 12.1768 9.97853 12.5156 10.0697C12.8544 10.1609 13.1633 10.3395 13.4114 10.5875C13.6595 10.8356 13.838 11.1445 13.9292 11.4833C14.0204 11.8221 14.021 12.1789 13.9309 12.518L15.4449 14.032C15.8959 13.268 16.0801 12.3758 15.9686 11.4957C15.857 10.6155 15.4561 9.79747 14.8288 9.17016C14.2014 8.54284 13.3834 8.14187 12.5033 8.03033C11.6234 7.91881 10.7308 8.10226 9.96694 8.55298Z",
    fill: "#B0BABF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.749 15.992L14.453 18.697C13.668 18.895 12.846 19 11.999 19C7.52203 19 3.73103 16.057 2.45703 12C2.85138 10.7469 3.48924 9.58402 4.33403 8.578L8.00703 12.251C8.06821 13.2233 8.48212 14.1398 9.17109 14.8286C9.86006 15.5174 10.7767 15.9311 11.749 15.992Z",
    fill: "#B0BABF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeoff);
export default __webpack_public_path__ + "static/media/Eyeoff.3d48963497b6773cd2f694cbfa775701.svg";
export { ForwardRef as ReactComponent };